import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export const MainContentHeader = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "h1",
    typography: "heading-500",
    children: children
  });
};